import Page from '@admin/components/page'
import Publishings from './publishings'
import Copyright from './copyright'
import Overview from './overview'
import Variants from './variants'
import Design from './design'
import React from 'react'

const mapPropsToPage = (props, context, resources, page) => ({
  title: resources.social_campaign.title,
  manager: {
    path: `/admin/truevail/agency/social_campaigns/${resources.social_campaign.id}`,
    items: [
      {
        label: 't(Overview)',
        panel: <Overview social_campaign={ resources.social_campaign } />
      },
      {
        label: 't(Variants)',
        path: '/variants',
        panel: <Variants social_campaign={ resources.social_campaign } />
      },
      {
        label: 't(Design)',
        path: '/design',
        panel: <Design social_campaign={ resources.social_campaign } />
      },
      {
        label: 't(Copyright)',
        path: '/copyright',
        panel: <Copyright social_campaign={ resources.social_campaign } />
      },
      {
        label: 't(Publishings)',
        path: '/publishings',
        panel: <Publishings social_campaign={ resources.social_campaign } />
      }
    ]
  }
})

const mapResourcesToPage = (props, context) => ({
  social_campaign: `/api/admin/truevail/agency/social_campaigns/${props.params.id}`
})

export default Page(mapResourcesToPage, mapPropsToPage)
